// Token expiration constants (in minutes)
export const TOKEN_EXPIRATION_TRUSTED_DEVICE = 30 * 24 * 60  // 30 days
export const TOKEN_EXPIRATION_REGULAR_SESSION = 60  // 1 hour
export const TOKEN_REFRESH_THRESHOLD = 50  // Refresh token when less than 50 minutes remain 